// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1tRj-","unreadBadge":"styles_unreadBadge__3aQIg","modalContent":"styles_modalContent__qf7Bp","modal":"styles_modal__2MhOp"};